import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import TextField from 'app/components/shared/TextField';

import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import { MATERIAL_TYPE_DIGITAL } from 'app/constants/BibConstants';
import accountShape from 'app/shapes/accountShape';

import './DigitalHoldForm.scss';

export class DigitalHoldForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      digitalNotificationEmail: this.props.currentAccount?.get('digitalNotificationEmail')
    };
    bindAll(this);
  }

  handleEmailChange(digitalNotificationEmail) {
    this.setState({
      digitalNotificationEmail
    });
  }

  handleDigitalHold() {
    const { holdActions, bib, handleClose, currentAccount } = this.props;
    const { digitalNotificationEmail } = this.state;

    holdActions.placeHold({
      accountId: currentAccount.get('id'),
      metadataId: bib.get('id'),
      postSuccess: handleClose,
      materialType: MATERIAL_TYPE_DIGITAL,
      enableSingleClickHolds: false,
      materialParams: {
        email: digitalNotificationEmail
      }
    });
  }

  renderNotificationEmailTextField() {
    return (
      <div className="digital-hold-notification-email">
        <TextField
          label={<FormattedMessage id="notification_email" />}
          type="email"
          id="digital-notification"
          onChange={this.handleEmailChange}
          value={this.state.digitalNotificationEmail}
          size="large"
        />
      </div>
    );
  }

  render() {
    const { bib, holdsTransactions, digitalFormats, intl } = this.props;
    const isPlacingHold = holdsTransactions.getIn([bib.get('id'), 'isPlacingHold'], false);
    const formatList = digitalFormats.map(digitalFormat => {
      return intl.formatMessage({
        id: `digiformat_${digitalFormat.get('name').toLowerCase()}`
      });
    });

    return (
      <div className="cp-digital-hold-form">
        <ModalHeader title={<FormattedMessage id="place_hold" />} />
        <ModalContent>
          <BibBriefContainer metadataId={bib.get('id')} />
          <div className="digital-hold-available-format">
            <FormattedMessage id="available_as" values={{ formats: formatList.join(', ') }} />
          </div>
          {this.renderNotificationEmailTextField()}
        </ModalContent>
        <ModalFooter
          primaryActionButtonTag={TransactionalSolidButton}
          primaryActionButtonText={<FormattedMessage id="place_hold" />}
          isLoading={isPlacingHold}
          handlePrimaryAction={this.handleDigitalHold}
          disabled={!this.state.digitalNotificationEmail}
        />
      </div>
    );
  }
}

DigitalHoldForm.propTypes = {
  bib: bibShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  digitalFormats: ImmutablePropTypes.list,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentAccount: accountShape
};

export default injectIntl(DigitalHoldForm);
